// ThemeService.js - Updated for reliable theme switching
const ThemeService = {
  // Theme options
  LIGHT: 'light',
  DARK: 'dark',
  
  // Local storage key 
  STORAGE_KEY: 'digitables-theme',
  
  // Get current theme
  getCurrentTheme() {
    return localStorage.getItem(this.STORAGE_KEY) || this.LIGHT;
  },
  
  // Set and apply theme
  setTheme(theme) {
    console.log('Setting theme to:', theme);
    
    // First remove both classes to avoid conflicts
    document.documentElement.classList.remove(this.LIGHT, this.DARK);
    
    // Then add the selected theme class
    document.documentElement.classList.add(theme);
    
    // Force a small delay to ensure the browser applies the class change
    setTimeout(() => {
      console.log('Current document class:', document.documentElement.className);
    }, 50);
    
    // Save to localStorage
    localStorage.setItem(this.STORAGE_KEY, theme);
    
    return theme;
  },
  
  // Toggle between light and dark mode
  toggleTheme() {
    const currentTheme = this.getCurrentTheme();
    const newTheme = currentTheme === this.LIGHT ? this.DARK : this.LIGHT;
    return this.setTheme(newTheme);
  },
  
  // Initialize theme on app load
  initialize() {
    // Make sure we initialize the theme right when the document is ready
    const savedTheme = this.getCurrentTheme();
    console.log('Initializing theme to:', savedTheme);
    return this.setTheme(savedTheme);
  }
};

export default ThemeService;